import tierDefinitions from "../../data/tierDefinitions.json";
import { COURSE_FEATURE } from "../../data/course";

/**
 * Resolve a tier's feature keys, following `inherits`.
 *
 * Mirrors the backend's tierHasAccess so the UI and the API agree on who can
 * open a deck. tierDefinitions.json is the single source of truth for both.
 */
export const featuresForTier = (tier: string): string[] => {
  const defs = tierDefinitions as Record<string, any>;
  const seen = new Set<string>();
  const walk = (t: string) => {
    const def = defs[t];
    if (!def) return;
    (def.features || []).forEach((f: string) => seen.add(f));
    (def.inherits || []).forEach(walk);
  };
  walk(tier);
  return [...seen];
};

/** Whether a tier unlocks the paid course decks. */
export const hasCourseAccess = (tier: string): boolean =>
  featuresForTier(tier).includes(COURSE_FEATURE);
